import { tableCellText, type TableCellValue } from "../components/ui/TableCell/TableCell";

const WORDS_PER_MINUTE = 200;

interface ContentBlock {
    text?: string;
    heading?: string;
    list?: string[];
    parts?: Array<string | { label: string }>;
    kanjiMeaningGrid?: Array<{ meaning: string }>;
    table?: { caption: string; headers: string[]; rows: TableCellValue[][] };
}

function blockText(block: ContentBlock): string {
    if (block.text) return block.text;
    if (block.heading) return block.heading;
    if (block.list) return block.list.join(" ");
    if (block.parts) {
        return block.parts.map((part) => (typeof part === "string" ? part : part.label)).join(" ");
    }
    if (block.kanjiMeaningGrid) {
        return block.kanjiMeaningGrid.map((item) => item.meaning).join(" ");
    }
    if (block.table) {
        const cells = block.table.rows.flatMap((row) => row.map(tableCellText));
        return [block.table.caption, ...block.table.headers, ...cells].join(" ");
    }
    return "";
}

export function estimateReadingMinutes(content: ContentBlock[]): number {
    const wordCount = content.reduce((total, block) => {
        const text = blockText(block).trim();
        return total + (text ? text.split(/\s+/).length : 0);
    }, 0);
    return Math.max(1, Math.round(wordCount / WORDS_PER_MINUTE));
}
